import baseUrl from './base';

export const getTresoreries = ({ page } = { page: 1 }) => `${baseUrl}/tresoreries?page=${page}`;
